/**
 * <ScorecardResultsUserNoScoreColumnHeader /> renders an anonymous user avatar
 * and a greyed out "..." text label beneath the avatar to represent a user who has access
 * to the given FileUpload object but has left no feedback
 */
import React from 'react';
import UserAvatar from 'components/pure/utils/UserAvatar';
import GreyCardLabel from 'components/pure/utils/GreyCardLabel';

require('styles/scorecards/ScorecardResultsUserScoreColumnHeader.styl');
require('styles/scorecards/ScorecardResultsUserScoreNoColumnHeader.styl');

const classNames = require('classnames');

class ScorecardResultsUserNoScoreColumnHeader extends React.Component {
  render() {
    const containerClassname = classNames('user-no-score-column-header', this.props.className);
    return (
      <div className={containerClassname}>
        <UserAvatar />
        <GreyCardLabel label={`...`} className="user-no-score-label" />
      </div>
    );
  }
}

export default ScorecardResultsUserNoScoreColumnHeader;
